import React, { FC, useCallback } from 'react';
import { Info, Task } from '@mui/icons-material';
import { Chip, IconButton } from '@mui/material';
import MfButton from '../../UI/Button/MfButton';
import { StringCellValue } from '../../UI/MfResponsiveTable/MfResponsiveTable';
import { AgentProfileStatusEnum } from '../../../structures/response/AgentProfileInfo';
import {
  AgentRequestPrescoringStatusEnum,
  AgentRequestResponse,
} from '../../../structures/response/AgentRequestResponse';
import useAccount from '../../../hooks/useAccount';

interface Props {
  agentRequest: AgentRequestResponse;
  onSign: (v: AgentRequestResponse) => void;
  onPledgeConfirm: (v: AgentRequestResponse) => void;
}

const StatusCell: FC<Props> = ({ agentRequest, onSign, onPledgeConfirm }) => {
  const { accountResponse } = useAccount();

  const { statusLabel } = agentRequest;

  const agentProfileStatus =
    accountResponse?.agentProfileInfo?.status ||
    AgentProfileStatusEnum.WAIT_APPROVE;

  const showSign =
    agentProfileStatus === AgentProfileStatusEnum.APPROVED &&
    Boolean(agentRequest.report?.reportDocument) &&
    !agentRequest.report?.reportDocument?.isSigned;

  const showSignSuccess = agentRequest.report?.reportDocument?.isSigned;

  const showPledgeWarning =
    agentRequest.prescoringStatus ===
      AgentRequestPrescoringStatusEnum.ONLY_BY_TRANSPORT &&
    !agentRequest.hasPledge;

  const handlePledgeConfirmClick = () => onPledgeConfirm(agentRequest);

  return (
    <StringCellValue>
      <div>
        {statusLabel}{' '}
        {showPledgeWarning && (
          <IconButton
            sx={{ color: '#ED213A' }}
            onClick={handlePledgeConfirmClick}
          >
            <Info />
          </IconButton>
        )}
      </div>
      {showSign && (
        <MfButton
          variant="contained"
          size="small"
          sx={{
            whiteSpace: 'nowrap',
            mt: 1,
          }}
          onClick={() => onSign(agentRequest)}
        >
          Подписать документы
        </MfButton>
      )}
      {showSignSuccess && (
        <Chip
          sx={{ mt: 1 }}
          color="primary"
          icon={<Task />}
          size="small"
          variant="filled"
          label="Документы подписаны"
        />
      )}
    </StringCellValue>
  );
};

export default StatusCell;
